import { ChapterName } from '../types';

export const chapterNameMap: Record<ChapterName, string> = {
  FOUNDATION: 'ui.event-management.events.assign-chapters.foundation',
  MANAGEMENT: 'ui.event-management.events.assign-chapters.management',
  EFFECTIVE_SELLING:
    'ui.event-management.events.assign-chapters.effective-selling',
  PERSONAL_ACHIEVEMENT:
    'ui.event-management.events.assign-chapters.personal-achievement',
  CRITICAL_THINKING:
    'ui.event-management.events.assign-chapters.critical-thinking',
  INTERVIEW: 'ui.event-management.events.assign-chapters.interview',
  IDTL: 'ui.event-management.events.assign-chapters.insights-discovering-leadership-effectiveness',
  IMPACT: 'ui.event-management.events.assign-chapters.personal-impact',
  EXPLORE: 'ui.event-management.events.assign-chapters.insights-explore',
  DFC: 'ui.event-management.events.assign-chapters.insights-discovery-full-circle',
};
